/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Overwrite_Cancelled_ErrorInputs */



/**
* | output |
* | --- |
* | "Overwriting project was cancelled" |
*
* @param {Explorer_Info_Overwrite_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_overwrite_cancelled_error = /** @type {((inputs?: Explorer_Info_Overwrite_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Overwrite_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecrasement du projet annule")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Überschreibungsprojekt wurde abgebrochen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il progetto di sovrascrittura è stato annullato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект по перезаписи был отменен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se canceló el proyecto de sobrescritura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("覆盖项目已取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上書きプロジェクトはキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरराइटिंग परियोजना रद्द कर दी गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O projeto de sobrescrita foi cancelado.")
	return /** @type {LocalizedString} */ ("Overwriting project was cancelled")
});